import { render, staticRenderFns } from "./OsobaUmanjeniSatDetails.vue?vue&type=template&id=1913889c&scoped=true&"
import script from "./OsobaUmanjeniSatDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913889c",
  null
  
)

export default component.exports